





































import { checklistPostReq } from "@/services/checklist.service";
import { de } from "vuejs-datepicker/dist/locale";
import Datepicker from "vuejs-datepicker";
import moment from "moment";

export default {
  components: {
    Datepicker,
  },
  data() {
    return {
      date: new Date().toISOString().substr(0, 7),
      menu: false,
      modal: false,
      initLoaded: false,
      list: [],
      search: null,
      columns: ['email', 'name', 'age'],

      headers: [
        { text: "Erstellt", value: "created_at", sortable: true },
        { text: "Name", value: "name", sortable: true },
        { text: "Firma", value: "company", sortable: true },
        { text: "Benutzername", value: "username", sortable: true },
        { text: "Logins", value: "login_count", sortable: true },
        { text: "Letzter Login", value: "updated_at", sortable: true },
        { text: "Inspect", value: "version", sortable: true },
      ],
    };
  },
  mounted() {
    this.$store.state.headerTitle = "User";

    checklistPostReq("users-list", {})
      .then((resp) => {
        console.log("resp", resp);
        if (resp.data && resp.data) {
          this.list = resp.data;
        }

        this.initLoaded = true;
      })
      .catch((e) => {
        this.$store.dispatch("api_error", e);
      });
  },
  methods: {

    customFormatter(date) {
      return moment(date).format("MMMM YYYY");
    },

    convertToCsv(data, headers) {
      const csvRows = [];
      const headerTitles = headers.map(header => header.text);
      csvRows.push(headerTitles.join(','));

      for (const row of data) {
        const values = headers.map(header => {
          let value = row[header.value];

          if (header.value === 'created_at' || header.value === 'updated_at') {
            value = moment(value).format("DD.MM.YYYY HH:mm");
          }
        

          const escaped = ('' + value).replace(/"/g, '\\"');
          return `"${escaped}"`;
        });
        csvRows.push(values.join(','));
      }

      return csvRows.join('\n');
    },

    downloadCsv() {
      const csvData = this.convertToCsv(this.list, this.headers);
      const blob = new Blob([csvData], { type: 'text/csv' });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = 'data.csv';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    }

   
  },
};
